angular
  .module('contrast.factory.message', [])
  .factory('MessageFactory', function ($http) {
    return {
      getNextMessage: function () {
        //do not require orgUuid
        return $http.get('/Contrast/api/ng/messages/next')
      }
    }
  })
